/**
 * 常量
 */
export default {
  
}